import ProductVariant from '@/shared/types/products/productVariant.type';

const getOptionValue = (option: ProductVariant) => {
  const { variant_name, product_name, variant_id } = option;
  const variantId = variant_id.split('-')[0];

  if (product_name && variant_name) {
    if (variant_name === '_default') {
      return `${product_name}: ${variantId}`;
    }
    return `${product_name}: ${variant_name}: ${variantId}`;
  } else if (product_name && !variant_name) {
    return `${product_name}: ${variantId}`;
  } else if (!product_name && variant_name) {
    return `${variant_name}: ${variantId}`;
  } else {
    return `No product or variant name: ${variantId}`;
  }
};

export default getOptionValue;
